import { Link } from "react-router-dom";
import { Container } from "./UI";
import logo from "../../Images/client/brand/suryanirbhar-wordmark-cropped.png";
import { FaFacebookF, FaInstagram, FaLinkedinIn, FaWhatsapp, FaYoutube } from "react-icons/fa";
const socials = [
  ["Instagram", "https://www.instagram.com/suryanirbhar_agritech_/", FaInstagram],
  ["LinkedIn", "https://www.linkedin.com/company/suryanirbhar-agritech/", FaLinkedinIn],
  ["YouTube", "https://youtube.com/@suryanirbhar_agritech?si=uNhjJx-LTAuU1Ows", FaYoutube],
  ["Facebook", "https://www.facebook.com/suryanirbhar.agritech/", FaFacebookF],
  [
    "WhatsApp",
    "https://wa.me/919380226919?text=Hello%20I%20want%20to%20know%20about%20your%20products",
    FaWhatsapp,
  ],
];
export default function HomeFooter() {
  return (
    <footer className="sn-bg-forest sn-pb-6 sn-pt-14 sn-text-cream">
      <Container>
        <div className="sn-grid sn-gap-10 md:sn-grid-cols-[1.2fr_1.6fr_1fr] md:sn-gap-12">
          <div>
            <Link
              to="/"
              aria-label="Suryanirbhar Agritech home"
              className="sn-inline-flex sn-w-full sn-max-w-[360px] sn-rounded-lg focus-visible:sn-outline focus-visible:sn-outline-2 focus-visible:sn-outline-offset-4 focus-visible:sn-outline-cream"
            >
              <img
                src={logo}
                width="4969"
                height="1269"
                alt="Suryanirbhar Agritech - Electrifying Traditional Agriculture"
                className="sn-h-auto sn-w-full sn-object-contain"
              />
            </Link>
          </div>
          <div>
            <h2 className="sn-mb-4 sn-text-[11px] sn-uppercase sn-tracking-[0.18em] sn-text-cream/60">
              Explore
            </h2>
            <ul className="sn-flex sn-flex-wrap sn-gap-x-5 sn-gap-y-1">
              {[
                ["About us", "/about"],
                ["Our machines", "/products"],
                ["Farmer stories", "/testimonials"],
                ["Newsletter", "/blog"],
                ["Contact", "/contact"],
              ].map(([name, path]) => (
                <li key={path}>
                  <Link
                    className="sn-inline-flex sn-min-h-[40px] sn-items-center sn-text-sm hover:sn-underline"
                    to={path}
                  >
                    {name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2 className="sn-mb-4 sn-text-[11px] sn-uppercase sn-tracking-[0.18em] sn-text-cream/60">
              Stay connected
            </h2>
            <ul className="sn-flex sn-flex-wrap sn-gap-3">
              {socials.map(([name, url, Icon]) => (
                <li key={name}>
                  <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`${name} (opens in a new tab)`}
                    title={name}
                    className="sn-inline-flex sn-h-11 sn-w-11 sn-items-center sn-justify-center sn-rounded-full sn-border sn-border-cream/25 sn-text-cream hover:sn-bg-white hover:sn-text-forest"
                  >
                    <Icon aria-hidden="true" className="sn-h-4 sn-w-4" />
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="sn-mt-6 sn-flex sn-flex-col sn-gap-2 sn-border-t sn-border-white/20 sn-pt-5 sn-text-xs sn-text-cream/60 sm:sn-flex-row sm:sn-justify-between">
          <p>
            © {new Date().getFullYear()} Suryanirbhar Agritech Pvt Ltd
            <span className="sn-mx-2" aria-hidden="true">
              •
            </span>
            Designed by{" "}
            <a
              href="https://ekathvainnovations.com"
              target="_blank"
              rel="noopener noreferrer"
              className="sn-text-cream/85 sn-underline-offset-4 hover:sn-text-cream hover:sn-underline"
            >
              Ekathva Innovations
            </a>
          </p>
          <p>All rights reserved.</p>
        </div>
      </Container>
    </footer>
  );
}
